import React, { FC } from "react";
import LogoLogin from "../../static/svg/LogoLogin";
import LoginImage from "../../static/images/LoginImage.png";
import TestServerQR1 from "../../static/svg/TestServerQR1"
import UatQR1 from "../../static/svg/UatQR1";
interface AuthTemplateProps {
  title: string;
  form: React.ReactNode;
}

const AuthCard: FC<AuthTemplateProps> = ({ title, form }) => {
  const currentUrl = window.location.href;
  return (
    <div className="container-fluid h-100 Login">
      <div className="row">
        <div className="col-md-7 px-0">
          <div className="position-relative">
            <img src={LoginImage} alt="profile" className={`h_100vw w-100`} />
          </div>
        </div>
        <div className="col-md-5 m-auto login_rightSide">
          <div className="Loginpage">
            <div className="">
              <div className="text-center mb-4">
                {/* {title} */}
                <span className="">
                  <LogoLogin />
                </span>
              </div>
              <p className="text-blue  text-center">Sign in by using QR code</p>
              <div className="container w-50 mx-auto">
                {/*uat url https://uat.app.crew-ai.infanion.com/login */}
                {/*test url https://test.app.crew-ai.infanion.com/login */}
                {currentUrl === "https://uat.app.crew-ai.infanion.com/login" ? (
                  <UatQR1 />
                ) : (<>
                  <TestServerQR1 />
                </>
                )}
                <span className="or my-4">Or</span>

              </div>

            </div>
          </div>

          <div className="Login-form pt-5">{form}</div>
        </div>
      </div>
    </div>
  );
};

export default AuthCard;
